// Define a convenience method and use it like
// ready(() => {...});
var ready = (callback) => {
  if (document.readyState != 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/*
 * HISTORY STATE
 * Check if window.history is supported
 */
function historyState() {
  return window.history && window.history.replaceState;
}

/*
 * GET URL PARAMETER
 * Checks for url parameter called `name`.
 */
function getParam(name) {
  if ('URLSearchParams' in window) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  } else {
    // Polyfill for IE11
    var params = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (params == null) {
      return null;
    } else {
      return decodeURI(params[1]) || 0;
    }
  }
}

ready(function () {
  handleNumberStepper();
  handleVariantSelector();
  handleScrollys();
  handleMobileFooter();
  handleMobileNav();
  handleNavToggles();
  handleCloseDropdownMenus();
  handlePromotionSlider();
});

/*
 * FORMAT MONEY
 * Formats the passed value as money with currency symbol.
 * Referenced from https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 */
var Shopify = Shopify || {};
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/*
 * OPTION SELECTOR
 * Works the variant option dropdowns used on the
 * product page template.
 */
function handleVariantSelector() {
  let variant;
  let options = [];
  options[1] = null;
  options[2] = null;
  options[3] = null;

  const variantOptions = document.querySelectorAll('.js--variant-option');
  variantOptions.forEach(function (el) {
    el.addEventListener('change', function (event) {
      // Disable non-existent variant options.
      checkVariants();

      // Set the chosen options.
      variantOptions.forEach(function (opt) {
        if (opt.tagName.toLowerCase() === 'input' && opt.checked == true) {
          let optionName = opt.getAttribute('name');
          let optionPos = parseInt(optionName.replace('option', ''));
          let optionValue = opt.value;
          options[optionPos] = optionValue;
        }
      });

      // Loop through the variants and get the selected one.
      variants.filter(function (v) {
        if (v.option1 === options[1] && v.option2 === options[2] && v.option3 === options[3]) {
          variant = v;

          // Update variant id and prices
          document.querySelector('input#js--variant-id').value = v.id;
          // The following is used for the "purchase together" feature.
          document.querySelectorAll('input[type="checkbox"].js--variant-id').forEach(function (el) {
            el.value = v.id;
            el.setAttribute('data-price', v.price);
            if (v.available === true) {
              el.checked = true;
              el.disabled = false;
            } else {
              el.checked = false;
              el.disabled = true;
            }
          });
          document.querySelectorAll('.js--variant-price').forEach(function (el) {
            el.innerHTML = Shopify.formatMoney(v.price);
          });

          if (v.compare_at_price > v.price) {
            document.querySelectorAll('.js--variant-compareatprice').forEach(function (el) {
              el.innerText = Shopify.formatMoney(v.compare_at_price);
            });
          } else {
            document.querySelectorAll('.js--variant-compareatprice').forEach(function (el) {
              el.innerText = '';
            });
          }

          // Update SKU
          document.querySelectorAll('.js--variant-sku').forEach(function (el) {
            el.innerText = variant.sku;
          });

          // Disable the buy button/product add-ons if product is unavailable
          if (v.available === false) {
            document.querySelector('#js--addtocart').disabled = true;
            document.querySelector('#js--addtocart').innerText = 'Unavailable';
            document.querySelector('.dynamic_checkout_buttons').style.display = "none";
            if (document.getElementById('package-addons')) {
              document.getElementById('package-addons').style.display = "none";
            }
          } else {
            document.querySelector('#js--addtocart').disabled = false;
            document.querySelector('#js--addtocart').innerText = 'Add to cart';
            document.querySelector('.dynamic_checkout_buttons').style.display = "";
            if (document.getElementById('package-addons')) {
              document.getElementById('package-addons').style.display = "";
            }
          }

          // Update image
          var imageId = v.featured_image != null ? v.featured_image.id : default_image;
          var imageIndex = document
            .querySelector('.product-image-item[data-imageid="' + imageId + '"]')
            .getAttribute('data-index');
          var sliderContainer = document.querySelector('.product-images-component');
          goToImage(imageIndex, sliderContainer);

          // Append the variant ID as a url parameter
          if (v !== undefined) {
            if (historyState()) {
              window.history.replaceState({}, document.title, '?variant=' + v.id);
            }
          }
        }
      });
    });
  });
}

/*
 * CHECK VARIANT EXISTS
 * This checks if the variant actually exists - e.g you may have small, medium,
 * and large in blue and black, but blue/medium is not a variant. Disables the
 * related inputs.
 */
function checkVariants() {
  let $this = event.target;
  if ($this !== undefined) {
    let availableVariants = new Set();
    variants.filter(function (variant, k) {
      if (variant[$this.name] === $this.value) {
        availableVariants.add(variant);
      }
    });

    // Loop through the array above to create an array containing available
    // option values.
    let optionGroups = {};
    availableVariants.forEach(function (variant) {
      let options = Object.entries(variant);
      for (const [key, value] of options) {
        if (value != null) {
          if (optionGroups[key] === undefined) {
            optionGroups[key] = [];
          }
          if (optionGroups[key].includes(value) === false) {
            optionGroups[key].push(value);
          }
        }
      }
    });

    // Then, loop through each input and check if its value is in the optionGroups
    // array created above, ignoring the clicked option group.
    document.querySelectorAll('.js--variant-option').forEach(function (input) {
      if (input.name !== $this.name) {
        if (optionGroups[input.name].includes(input.value) === false) {
          input.disabled = true;
          input.checked = false;
        } else {
          input.disabled = false;
        }
      }
    });
  }

  // Check a valid option is selected for each group.
  document.querySelectorAll('.js--variant-options').forEach(function (group) {
    let firstAvailable = null;
    let checkedOptions = group.querySelectorAll('.js--variant-option:checked').length;
    if (checkedOptions === 0) {
      firstAvailable = group.querySelectorAll('.js--variant-option:not(:disabled)')[0];
    }
    if (firstAvailable != null) {
      firstAvailable.checked = true;
    }
  });
}

/*
 * TOGGLE MOBILE NAV
 * Open/close main nav on mobile. This just applies a class
 * and the rest is done in CSS.
 */
function toggleNav() {
  let nav = document.querySelector('#header-nav');
  nav.classList.toggle('nav-open');
}

/*
 * Work the dropdowns within the mobile nav menu.
 */
function handleMobileNav() {
  let nav = document.querySelector('#header-nav');
  if (window.innerWidth <= 1100) {
    let dropdowns = nav.querySelectorAll('.has-dropdown');
    dropdowns.forEach(function (dropdown) {
      dropdown.querySelectorAll('.megamenu-grid-column_title, .megamenu-grid-column_image a').forEach(function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault();
          dropdown.classList.toggle('open');
        });
      });
    });
  }
}

/*
 * NUMBER INPUT STEPPER
 * Number stepper used for the quantity field.
 */
function handleNumberStepper() {
  let maxQty = 20;
  let minQty = 1;
  const steppers = document.querySelectorAll('.input-stepper');

  steppers.forEach(function (stepper) {
    let input = stepper.querySelector('input[type="number"]');
    let stepperButtons = stepper.querySelectorAll('button');
    let maxValue = input.getAttribute('max') !== undefined ? parseInt(input.getAttribute('max')) : maxQty;
    let minValue = input.getAttribute('min') !== undefined ? parseInt(input.getAttribute('min')) : minQty;

    stepperButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        let currentValue = parseInt(input.value);
        if (button.classList.contains('input-stepper_decrease')) {
          if (currentValue > minValue) {
            input.value = currentValue - 1;
          }
        }
        if (button.classList.contains('input-stepper_increase')) {
          if (currentValue < maxValue) {
            input.value = currentValue + 1;
          }
        }
      });
    });
  });
}

/*
 * HANDLE SCROLLY ROWS
 * Adds interactions to the horizontally scrolling sections.
 */
function handleScrollys() {
  const scrollBy = 3;
  const scrollys = document.querySelectorAll('.scrolly');
  scrollys.forEach(function (scrolly) {
    let scrollyParent = scrolly.parentElement;
    let scrollyItem = scrolly.firstElementChild;
    if (scrolly.scrollWidth > scrollyParent.offsetWidth) {
      scrollyParent.classList.add('scrolly-container');
      scrollyParent.insertAdjacentHTML(
        'beforeend',
        `<div class="scrolly-buttons section-wrap" data-device="desktop">
          <div class="section">
            <button type="button" class="scroll-left" disabled>
              <span>&larr;</span>
            </button>
            <button type="button" class="scroll-right">
              <span>&rarr;</span>
            </button>
          </div>
        </div>`,
      );
      let btnLeft = scrollyParent.querySelector('.scroll-left');
      btnLeft.addEventListener('click', function (event) {
        scrolly.scrollLeft -= scrollyItem.offsetWidth * scrollBy;
      });
      let btnRight = scrollyParent.querySelector('.scroll-right');
      btnRight.addEventListener('click', function (event) {
        scrolly.scrollLeft += scrollyItem.offsetWidth * scrollBy;
      });
      scrolly.addEventListener('scroll', function (event) {
        if (scrolly.scrollLeft > 0) {
          btnLeft.disabled = false;
        } else {
          btnLeft.disabled = true;
        }
      });
    }
  });
}

/*
 * Mobile Footer
 * Tab the footer for mobiles.
 */
function handleMobileFooter() {
  if (window.innerWidth <= 1100) {
    let html = '';
    const footer = document.querySelector('.js--footer-columns');
    let footerCols = footer.querySelectorAll('.footer-grid-column');
    footerCols.forEach(function (column) {
      let sections = column.querySelectorAll('.footer-column-section');
      sections.forEach(function (section) {
        let title = section.querySelector('.footer-column-title').innerText;
        let content = section.querySelector('.footer-column-content').innerHTML;
        // console.log({ title, content });
        html += `
          <details>
            <summary class="light-blue-text small-text semibold">${title}</summary>
            <div class="footer-details-content">
              ${content}
            </div>
          </details>`;
      });
    });
    footer.innerHTML = html;
  }
}

/*
 * Toggle Mobile Search
 */
function toggleMobileSearch() {
  const search = document.getElementById('header-search-mobile');
  search.classList.toggle('hide');
}

/*
 * Nav Menu Toggles
 * Handles the nav toggles, so only one menu is open at a  time.
 */
function handleNavToggles() {
  if (window.innerWidth > 1100) {
    const nav = document.getElementById('header-nav');
    let details = nav.querySelectorAll('details');
    details.forEach(function (detail) {
      detail.addEventListener('toggle', function (event) {
        if (detail.open) {
          document.body.classList.add('navOpen');
          details.forEach((otherDetail) => {
            if (otherDetail !== detail && otherDetail.open) {
              otherDetail.open = false;
            }
          });
        }
        if (nav.querySelector('details[open]')) {
          document.body.classList.add('navOpen');
        } else {
          document.body.classList.remove('navOpen');
        }
      });
    });
  }
}

function handleCloseDropdownMenus() {
  const nav = document.querySelector('#header-nav');
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      nav.querySelectorAll('details[open]').forEach((detail) => {
        detail.removeAttribute('open');
      });
    }
  });
}

/*
 * Promotions Slider
 * Handles the swipeable promotions on mobile.
 */
function handlePromotionSlider() {
  const sliderComponents = document.querySelectorAll('.promotions');
  sliderComponents.forEach(function (sliderComponent) {
    let slider = sliderComponent.querySelector('.promotions-grid');
    let totalSlides = slider.dataset.slides;

    // Loop through the slides and create the pagination,
    // setting data-index attributes on the grid-items and
    // the pagination options.
    let sliderItems = slider.querySelectorAll('.promotion-item');
    let pagination = '';
    if (sliderItems != null) {
      sliderItems.forEach(function (item, index) {
        let activeClass = '';
        item.setAttribute('data-index', index);
        if (index === 0) {
          activeClass = ' class="active"';
        }
        pagination += `
          <button type="button" ${activeClass} data-index="${index}">
            <span>${index}</span>
          </button>`;
      });
    }
    if (totalSlides > 1) {
      sliderComponent.insertAdjacentHTML(
        'beforeend',
        `<div class="promotion-controls" data-device="mobile">
        <div class="promotion-dots">${pagination}</div>
      </div>`,
      );
    }

    // Loop through all the slides and see which
    // one is visible in the viewport. If visible,
    // update the pagination.
    slider.addEventListener('scroll', function (event) {
      let $this = event.target;
      let sliderItems = $this.querySelectorAll('.promotion-item');
      let sliderPos = slider.scrollLeft;
      let pagination = sliderComponent.querySelector('.promotion-dots');
      const containerRect = slider.getBoundingClientRect();
      sliderItems.forEach(function (el, index) {
        let elementRect = el.getBoundingClientRect();
        if (elementRect.left >= containerRect.left && elementRect.right <= containerRect.right) {
          let slideIndex = el.getAttribute('data-index');
          pagination.querySelectorAll('button').forEach(function (button) {
            button.classList.remove('active');
          });
          pagination.querySelector('button[data-index="' + slideIndex + '"]').classList.add('active');
        }
      });
    });
  });
}
